 var swiper = new Swiper(".mySwiper.custom-collection", {
     loop:false,
        pagination: {
          el: ".swiper-pagination",
          clickable:true,
        },
        speed:500,
        pauseOnMouseEnter: true,
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 500,
          },
          500: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        },
    });